import type {
  LeadTimesData,
  LeadTimesDataApi,
  ResponseClustersData,
  ResponseClustersDataApi,
} from './interfaces'

export const toResponseClustersData = (
  responseClustersDataApi: ResponseClustersDataApi,
): ResponseClustersData => {
  return {
    data: toLeadTimesData(responseClustersDataApi.data),
    pagination: responseClustersDataApi.pagination,
  }
}

export const toLeadTimesData = (leadTimesApi: LeadTimesDataApi[]): LeadTimesData[] => {
  return leadTimesApi.map((item) => ({
    description: item.description,
    keyAccountsTime: item.LeadTimeCliente, // NOTE: Assuming property LeadTimeCliente as keyAccountsTime
    leadTime: item.leadTime,
    leadTimeAesp: item.LeadTimeAesp,
    leadTimeDtc: item.LeadTimeDtc,
    material: item.material,
    technology: item.technology,
  }))
}
